export default [
  {
    id: 'VEHICLE_ARRIVED',
    check_api: '/timestamps/arrived?is_draft=true',
    confirm_api: '/timestamps/arrived',
    api_key_date: 'arrived_at',
    elapsed_times: [
      {
        id: 'sla_breach',
        title: 'SLA BREACH',
      }],
  },
  // {
  //   id: 'REPORTED',
  //   check_api: '/timestamps/reported?is_draft=true',
  //   confirm_api: '/timestamps/reported',
  //   api_key_date: 'reported_at',
  //   elapsed_times: [{
  //     id: 'loading_detention',
  //     title: 'LOADING DETENTION',
  //   }],
  // },
  {
    id: 'DISPATCHED_AT',
    check_api: '/timestamps/dispatched?is_draft=true',
    confirm_api: '/timestamps/dispatched',
    api_key_date: 'dispatched_at',
    elapsed_times: [{
      id: 'loading_detention',
      title: 'LOADING DETENTION',
    },
    {
      id: 'expected_delivery_date',
      title: 'EXPECTED DELIVERY DATE',
    },
    ],
  },
  {
    id: 'CONSIGNEE_REPORTED_AT',
    check_api: '/timestamps/consignee_reported_at?is_draft=true',
    confirm_api: '/timestamps/consignee_reported_at',
    api_key_date: 'reported_at',
    elapsed_times: [{
      id: 'transit_delay',
      title: 'TRANSIT DELAY',
    },
    ],
  },
  {
    id: 'RELEASED_AT',
    check_api: '/timestamps/release_at?is_draft=true',
    confirm_api: '/timestamps/release_at',
    api_key_date: 'released_at',
    elapsed_times: [{
      id: 'unloading_detention',
      title: 'UNLOADING DETENTION',
    }],
  },
  {
    id: 'ACCEPTANCE_SLA',
    elapsed_times: [
      {
        id: 'acceptance_sla_breach',
        title: 'ACCEPTANCE SLA BREACH',
      }],
  },
  {
    id: 'INDENT_ACCEPTED',
    elapsed_times: [
      {
        id: 'acceptance_sla_breach',
        title: 'ACCEPTANCE SLA BREACH',
      },
    ],
  },
];
